"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerLimit = void 0;
var SchedulerLimit;
(function (SchedulerLimit) {
    SchedulerLimit["LIMIT1"] = "LIMIT1";
    SchedulerLimit["LIMIT2"] = "LIMIT2";
    SchedulerLimit["LIMIT3"] = "LIMIT3";
    SchedulerLimit["LIMIT4"] = "LIMIT4";
    SchedulerLimit["LIMIT5"] = "LIMIT5";
    SchedulerLimit["LIMIT6"] = "LIMIT6";
    SchedulerLimit["LIMIT7"] = "LIMIT7";
    SchedulerLimit["LIMIT8"] = "LIMIT8";
    SchedulerLimit["LIMIT9"] = "LIMIT9";
    SchedulerLimit["LIMIT10"] = "LIMIT10";
    SchedulerLimit["UNLIMITED"] = "UNLIMITED";
})(SchedulerLimit = exports.SchedulerLimit || (exports.SchedulerLimit = {}));
